var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.41366 9.41368C9.23056 9.61017 9.00976 9.76778 8.76443 9.87709C8.5191 9.9864 8.25426 10.0452 7.98572 10.0499C7.71718 10.0547 7.45043 10.0053 7.2014 9.90467C6.95236 9.80408 6.72614 9.65436 6.53622 9.46444C6.34631 9.27453 6.19659 9.0483 6.096 8.79927C5.99541 8.55023 5.94601 8.28349 5.95075 8.01495C5.95549 7.74641 6.01426 7.48157 6.12358 7.23624C6.23289 6.99091 6.39049 6.77011 6.58699 6.58701M11.9603 11.9603C10.8207 12.829 9.43306 13.3103 8.00033 13.3337C3.33366 13.3337 0.666992 8.00034 0.666992 8.00034C1.49625 6.45494 2.64642 5.10475 4.04033 4.04034L11.9603 11.9603ZM6.60032 2.82701C7.05921 2.7196 7.52903 2.6659 8.00033 2.66701C12.667 2.66701 15.3337 8.00034 15.3337 8.00034C14.929 8.75741 14.4464 9.47017 13.8937 10.127L6.60032 2.82701Z",
    stroke: "#CED2DC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.666992 0.666992L15.3337 15.3337",
    stroke: "#CED2DC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClose);
export default __webpack_public_path__ + "static/media/eyeClose.a01ebca770d5ad2ccaf70d770f46dd1d.svg";
export { ForwardRef as ReactComponent };